
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/packs/[pack]",
      function () {
        return require("private-next-pages/packs/[pack].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/packs/[pack]"])
      });
    }
  